import { createFileRoute } from '@tanstack/react-router'
import { RenewalWizardPage } from '../../features/renewal'
import { RenewalsAccessGuard } from './-renewalsAccess'

export const Route = createFileRoute('/_authenticated/renewals_/$renewalId')({
  component: RenewalWizardRoute,
})

function RenewalWizardRoute() {
  const { renewalId } = Route.useParams()

  return (
    <RenewalsAccessGuard>
      <RenewalWizardPage key={renewalId} renewalId={Number(renewalId)} />
    </RenewalsAccessGuard>
  )
}
